export class ClaimDetails {
  public claimId?: number;
  public lossDate: any; // Todo: Apply pre-persistence date formatting
  public lossTime: any;
  public timeZoneId: string;
  public claimReasonId: number;
  public claimDetails: string;
  public awareDate: any; // Todo: Apply pre-persistence date formatting
  public claimReason: string;
  public timeZone: string;
  public currentPage: number;
}
